import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {
  SimpleTable,
  SimpleTableBody,
  SimpleTableContainer,
  SimpleTableHead,
  SimpleTableHeader,
  SimpleTableRow,
  SimpleTableData,
  SimpleTableWrapper,
  TextButton
} from 'cdk-radial';
import { useSelector } from 'react-redux';
import Overlay from '../../Overlay/Overlay';
import { mapLocationsToTable } from './utils/utils';
import { sendAmplitudeData } from '../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../constants/amplitudeConstants';

const ZebraSimpleTableRow = styled(SimpleTableRow)`
  :nth-child(even) {
    background-color: rgba(21, 27, 37, 0.03);
    border-top: 1px solid #dcddde;
  }
  &:last-child {
    border-bottom: none;
  }
`;

const ShowLocations = (props) => {
  let { gridParams } = props;

  const { data } = gridParams;

  const { isBulkSubscribed } = data;

  const state = useSelector((state) => state);
  const { allLocations } = state && state.loginDetailsSlice;
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    sendAmplitudeData(AMPLITUDE_EVENTS.LOCATION_COUNT, {
      [AMPLITUDE_PROPERTIES.APP_NAME]: data?.solutionData?.overview?.name,
      [AMPLITUDE_PROPERTIES.APP_ID]: data?.solutionData?.id,
      [AMPLITUDE_PROPERTIES.LOCATION_COUNT]: data?.location
    });

    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <TextButton
          dataTestId="text-button"
          iconColor="primary"
          onClick={handleOpen}
          text={data.location ? data.location : 'NA'}
        />
      </div>
      <Overlay
        active={isOpen}
        title={`Locations`}
        onOverlayClose={handleOpen}
        hideFirstButton={true}
        hideSecondButton={true}
      >
        <SimpleTableWrapper>
          <SimpleTableContainer>
            <SimpleTable aria-label="Table">
              <SimpleTableHead>
                <SimpleTableRow>
                  <SimpleTableHeader colSpan="1">
                    Dealership Location
                  </SimpleTableHeader>
                  <SimpleTableHeader colSpan="1">Address</SimpleTableHeader>
                  <SimpleTableHeader colSpan="1">Organization Id</SimpleTableHeader>
                 {!isBulkSubscribed &&  <SimpleTableHeader colSpan="1">CMF Number</SimpleTableHeader> }
                  <SimpleTableHeader colSpan="1">
                  {data.method==='Activation' ? 'Activated On' : 'Subscribed On' }
                  </SimpleTableHeader>
                </SimpleTableRow>
              </SimpleTableHead>
              <SimpleTableBody>
                {mapLocationsToTable(data.subscriptionData, allLocations,isBulkSubscribed).map(
                  (subscription, index) => (
                    <ZebraSimpleTableRow key={index}>
                      <SimpleTableData>{subscription.location}</SimpleTableData>
                      <SimpleTableData textAlign="right">
                        {subscription.address}
                      </SimpleTableData>
                      <SimpleTableData textAlign="left">
                        {subscription.entityId}
                      </SimpleTableData>
                      {!isBulkSubscribed && 
                       <SimpleTableData textAlign="center">
                        {subscription.cmfNumber}
                      </SimpleTableData> }
                      <SimpleTableData textAlign="right">
                        {subscription.subscribedOn
                          ? moment(subscription.subscribedOn)
                              .format('MM/DD/YYYY HH:mm:ss')
                          : 'NA'}
                      </SimpleTableData>
                    </ZebraSimpleTableRow>
                  )
                )}
              </SimpleTableBody>
            </SimpleTable>
          </SimpleTableContainer>
        </SimpleTableWrapper>
      </Overlay>
    </>
  );
};

export default ShowLocations;
